import style from './Portfolio.module.css';
import NumberFormatter from "../libs/NumberFormatter";

export default function Portfolio(
    props: {marketValue: number, cash: number, portfolio: Record<string, {fractions: number}>}
) {

    return (
        <div>
            <div className="py-2 border-b border-t border-gray-300
            overflow-scroll no-scrollbar">
                <div className="px-4 flex text-xs">
                    <div className="pr-6">
                        <span className={style.tickerLabel}>CASH</span>
                        <span className="pl-2">{NumberFormatter.toCurrency(props.cash)}</span>
                    </div>
                    <div className="pr-6">
                        <span className={style.tickerLabel}>MKTVALUE</span>
                        <span className="pl-2">{NumberFormatter.toCurrency(props.marketValue)}</span>
                    </div>
                    {
                        Object.entries(props.portfolio).map(([symbol, ticker]) =>
                            <div className="pr-6">
                                <span className={style.tickerLabel}>{symbol}</span>
                                <span className="pl-2">{NumberFormatter.toNumber(ticker.fractions, 3)}u</span>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );

}